export default "__VITE_ASSET__1c0dc746__"